import { render, staticRenderFns } from "./PersonSkeleton.vue?vue&type=template&id=5c08ffb2&"
import script from "./PersonSkeleton.vue?vue&type=script&lang=js&"
export * from "./PersonSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c08ffb2')) {
      api.createRecord('5c08ffb2', component.options)
    } else {
      api.reload('5c08ffb2', component.options)
    }
    module.hot.accept("./PersonSkeleton.vue?vue&type=template&id=5c08ffb2&", function () {
      api.rerender('5c08ffb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/people/PersonSkeleton.vue"
export default component.exports